import { createAction, handleActions } from "redux-actions";
import _size from "lodash/size";
import isEmail from "validator/lib/isEmail";
//
import Api from "../../services/Api";
import socket from "../../services/socket";
import { ajaxErrorAction } from "../ajax";
import { goToBack } from "../modal";
import {
  getModelsOfflineAction,
  getModelsFavoriteAction,
  showModelAction,
} from "../models/actions";
import { BOOKING_CREATE } from "../booking/actions";

// ----------------------------------------------------------------------------------------------------------------------------
//  Actions
// ----------------------------------------------------------------------------------------------------------------------------
import {
  LOGIN,
  LOGIN_ERROR,
  USER_GET,
  USER_LOCATION_SET,
  MESSAGE_NEW,
  USER_MESSAGES_CLEAR,
} from "./actionTypes";

export const setUserLocationAction = createAction(USER_LOCATION_SET);

const getUserPendingAction = createAction(USER_GET.PENDING);

const getUserFulfilledAction = createAction(USER_GET.FULFILLED);

const getUserRejectedAction = createAction(USER_GET.REJECTED);

export const clearUserMessagesAction = createAction(USER_MESSAGES_CLEAR);

export function getUserAction() {
  return async (dispatch, getState) => {
    dispatch(getUserPendingAction());
    try {
      const user = await Api.getUser();

      socket
        .messageCreated$(user.id)
        .subscribe((data) => dispatch(newMessageAction(data.message.id)));

      dispatch(getUserFulfilledAction(user));
    } catch (err) {
      dispatch(getUserRejectedAction(err));
    }
  };
}

const newMessageAction = createAction(MESSAGE_NEW);
const loginPendingAction = createAction(LOGIN.PENDING);
const loginErrorAction = createAction(LOGIN_ERROR);
export const loginAction = (email, password) => async (dispatch, getState) => {
  const errors = {};

  if (!email || !isEmail(email)) {
    errors["email"] = true;
  }
  if (!password) {
    errors["password"] = true;
  }

  // errors can be empty here.
  dispatch(loginErrorAction(errors));

  if (!_size(errors)) {
    dispatch(loginPendingAction());

    try {
      await Api.login(email, password);

      const res = await Api.getUser();

      dispatch(getUserFulfilledAction(res));
      dispatch(goToBack());

      // Load latest viewed model profile
      const { models } = getState();
      if (models.active) {
        dispatch(showModelAction(models.active));
      }

      dispatch(getModelsOfflineAction());
      dispatch(getModelsFavoriteAction());
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  }
};

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const initialState = {
  user: null,
  errors: [],
  isLoggedIn: false,
  isPremium: false,
  lat: null,
  lng: null,
  messages: [],
  trusted: false,
  verified: false,
  ga: null, // Google Analytics Client ID
};

export default handleActions(
  {
    [USER_GET.FULFILLED]: applySetUser,
    [LOGIN_ERROR]: applyLoginError,
    [USER_LOCATION_SET]: applyUserLocation,
    [MESSAGE_NEW]: applyNewMessage,
    [USER_MESSAGES_CLEAR]: applyClearUserMessages,
    [BOOKING_CREATE.FULFILLED]: applyBookingFulfilled,
    GA_CLIENT_ID: applyGa,
  },
  initialState
);

// ----------------------------------------------------------------------------------------------------------------------------
//  Action Reducers
// ----------------------------------------------------------------------------------------------------------------------------
function applySetUser(state, action) {
  const user = action.payload;
  const isLoggedIn = Boolean(user);

  return {
    ...state,
    user,
    isLoggedIn,
    isPremium: isLoggedIn && user.premium,
    messages: user.messages.slice(),
  };
}

function applyClearUserMessages(state) {
  return { ...state, messages: [] };
}

function applyLoginError(state, action) {
  return {
    ...state,
    errors: action.payload,
  };
}

function applyUserLocation(state, action) {
  const { lat, lng } = action.payload;

  return { ...state, lat, lng };
}

function applyNewMessage(state, action) {
  const messageId = action.payload;
  let messages = state.messages.filter((id) => id !== messageId);

  messages.push(messageId);

  return { ...state, messages };
}

function applyBookingFulfilled(state, action) {
  const { verified, trusted } = action.payload;

  return {
    ...state,
    // Note: This is booking.user.verified sent back by Backend
    verified,
    trusted,
  };
}

function applyGa(state, { payload }) {
  return {
    ...state,
    ga: payload,
  };
}
